"use client"

import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Menu, X } from "lucide-react"
import logo from "../assets/logo.png"

export default function Header({ toggleMobileMenu, mobileMenuOpen, seccion, handleNavClick }) {
  const [titleLoaded, setTitleLoaded] = useState(false)

  useEffect(() => {
    // Activar la animación del título después de un breve retraso
    setTimeout(() => {
      setTitleLoaded(true)
    }, 300)
  }, [])

  return (
    <header className="header-ini">
      <div className="container-ini">
        <div className="header-content-ini">
          <div className={`logo-ini ${titleLoaded ? "title-loaded-ini" : ""}`}>
            <img src={logo || "/placeholder.svg"} alt="Parking Club Logo" className="logo-image-ini" />
            <div className="logo-text-wrapper-ini notranslate" translate="no">
              <div className="title-animation-container-ini">
                <span className="logo-parking-ini">Parking</span>
                <span className="logo-club-ini">Club</span>
              </div>
            </div>
          </div>
          <nav className="nav-ini desktop-nav-ini">
            <ul>
              <li className={seccion === "inicio" ? "active-ini" : ""} onClick={() => handleNavClick("inicio")}>
                Inicio
                {seccion === "inicio" && <div className="nav-indicator-ini"></div>}
              </li>
              <li className={seccion === "nosotros" ? "active-ini" : ""} onClick={() => handleNavClick("nosotros")}>
                Nosotros
                {seccion === "nosotros" && <div className="nav-indicator-ini"></div>}
              </li>
              <li className={seccion === "servicios" ? "active-ini" : ""} onClick={() => handleNavClick("servicios")}>
                Servicios
                {seccion === "servicios" && <div className="nav-indicator-ini"></div>}
              </li>
              <li className={seccion === "beneficios" ? "active-ini" : ""} onClick={() => handleNavClick("beneficios")}>
                Beneficios
                {seccion === "beneficios" && <div className="nav-indicator-ini"></div>}
              </li>
              <li className={seccion === "descargar" ? "active-ini" : ""} onClick={() => handleNavClick("descargar")}>
                Descargar
                {seccion === "descargar" && <div className="nav-indicator-ini"></div>}
              </li>
              <li
                className={seccion === "contactanos" ? "active-ini" : ""}
                onClick={() => handleNavClick("contactanos")}
              >
                Contáctanos
                {seccion === "contactanos" && <div className="nav-indicator-ini"></div>}
              </li>
              <li>
                <Link to="/login" className="nav-link-ini">
                  Login
                </Link>
              </li>
            </ul>
          </nav>
          <button
            className="mobile-menu-button-ini"
            onClick={toggleMobileMenu}
            aria-label={mobileMenuOpen ? "Cerrar menú" : "Abrir menú"}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </header>
  )
}
